import { render, staticRenderFns } from "./HistoricoRelatorios.vue?vue&type=template&id=228946d8"
import script from "./HistoricoRelatorios.vue?vue&type=script&lang=js"
export * from "./HistoricoRelatorios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports